module.exports = __webpack_public_path__ + "static/media/greenLines.4a8595cc.svg";